import PropTypes from 'prop-types';
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import classname from 'classname';

const TextAreaField = props => {
	const className = classname({
		'form-element textarea': true,
		active: isActive(props),
		'has-error': hasError(props),
		[props.className ? props.className : null]: !!props.className
	});

	return (
		<div className={className}>
			<textarea {...props.input}
				disabled={props.disabled}
				autoFocus={!!props.autoFocus}
				className="form-element__control font-proxima-nova-regular"
			/>
			<label className="form-element__label" htmlFor={props.input.name}>
				{hasError(props) ? `${props.placeholder} (${errorValue(props)})` : props.placeholder}
			</label>
			<div className={!isActive(props) ? 'hr active' : 'hr'} />
			{ props.children}
		</div>
	);
};

const isActive = props => props.meta.active || !isEmpty(props.input.value);
const hasError = props => props.meta.touched && props.meta.error;
const errorValue = props => {
	return props.meta.error;
};

TextAreaField.propTypes = {
	input: PropTypes.object,
	autoFocus: PropTypes.bool,
	intl: PropTypes.func,
	meta: PropTypes.object,
	placeholder: PropTypes.string,
	children: PropTypes.node,
	className: PropTypes.string,
	disabled: PropTypes.bool
};

export default TextAreaField;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/form-elements/textarea.js